export const pluralize = (value: number, singular: string, plural: string) =>
  value === 1 ? `${value} ${singular}` : `${value} ${plural}`;